import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');
  const [showNotification, setShowNotification] = useState(false);

  const handleSocialClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-charcoal-900 text-white relative">
      {/* Notification */}
      {showNotification && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white px-6 py-3 rounded-lg shadow-lg z-50 flex items-center gap-2">
          <i className="ri-information-line text-xl"></i>
          <span className="font-medium">Pas encore disponible pour le moment</span>
        </div>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Logo and description */}
          <div className="sm:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/15c1abdb2e0285c3498cde5ccf72ca8b.png" 
                alt="HAFY TOURS Logo" 
                className="w-24 h-24 sm:w-32 sm:h-32 md:w-36 md:h-36 object-contain bg-transparent"
                style={{ backgroundColor: 'transparent' }}
              />
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed text-sm sm:text-base">
              {t('footerDescription')}
            </p>
            <div className="flex flex-wrap gap-3 sm:gap-4">
              <button onClick={handleSocialClick} className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white"></i>
              </button>
              <button onClick={handleSocialClick} className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-white"></i>
              </button>
              <a href="https://wa.me/212666204299" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-white"></i>
              </a>
              <button onClick={handleSocialClick} className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-white"></i>
              </button>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-blue-400">{t('ourServices')}</h3>
            <ul className="space-y-2 text-gray-300 text-sm sm:text-base">
              <li><button onClick={() => scrollToSection('services')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">Transferts Aéroport</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">Circuits Touristiques</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">Transport VIP</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">Excursions Journée</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-blue-400 transition-colors cursor-pointer text-left">Services Canada</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-blue-400">{t('contact')}</h3>
            <div className="space-y-3 text-gray-300 text-sm sm:text-base">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-blue-400 flex-shrink-0"></i>
                <span className="break-all">+212 666-204299</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gold-500/20 rounded-lg flex items-center justify-center">
                  <i className="ri-mail-line text-gold-400 text-lg"></i>
                </div>
                <div>
                  <p className="text-gray-300 text-sm break-all">contact@hafytours.com</p>
                  <p className="text-gray-300 text-sm break-all">youssefhajir@yahoo.fr</p>
                </div>
              </div>
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-blue-400 flex-shrink-0 mt-1"></i>
                <span>Casablanca, Maroc • Montréal, Canada</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <p className="text-gray-400 text-xs sm:text-sm text-center">
            {t('copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
